<template>
  <v-container fluid class="pa-0 bbb">
    <v-flex style="height:10vh;">
      <v-layout align-center column justify-center style="height: 100%;" sm12>
      </v-layout>
      <div>
      </div>
    </v-flex>
    <v-container grid-list-xl text-xs-center align-content-center :style="contentSpacer">





      <div class="font-weight-black" :style="fontSizer" style="padding-top:5%">LUCAS DIMONTE</div>
      <div class="font-weight-thin" :style="fontSizer">designing up a storm {{this.$vuetify.breakpoint.name}}</div>




      <div style="padding-top:15%;">
        <v-card hover ripple flat > 
       
          <v-card-media src="http://ldm.io/imgL/tiles/iphonx.png" height="70vh">
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-media>
                       <v-card-text>
            <h2>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium amet at cupiditate dolorem doloribus esse expedita
              ipsum magnam necessitatibus neque, optio perferendis placeat porro quas quisquam repellat repellendus reprehenderit
              ut.
            </h2>
          </v-card-text>


          <v-spacer></v-spacer>
          <v-icon class="white--text">explore</v-icon>
        </v-card>

      </div>








    </v-container>







    <v-footer dark height="auto" style="margin-top:5%;">
      <v-card flat tile class="grey lighten-5 text-xs-center" style="width:100vw;">

        <v-card-text class="black--text">
          &copy;2018 —
          <strong>Lucas Di Monte</strong>
          <p>
            <a href="mailto:ldimonte@gmail.com">Ldimonte@gmail.com</a>
          </p>

        </v-card-text>
      </v-card>
    </v-footer>
  </v-container>





</template>

<script>
  export default {
    data() {
      return {
        items: [{
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
          }
        ]
      }
    },
    mounted() {
      console.log(this.$vuetify.breakpoint);
    },
    computed: {
      contentSpacer() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "width: 99%;";
          case "sm":
            return "width: 99%;";
          case "md":
            return "width: 80%;";
          case "lg":
            return "width: 70%;";
          case "xl":
            return "width: 10%;";
                  }
      },
      fontSizer() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "font-size: 2rem;";
          case "sm":
            return "font-size: 4rem;";
          case "md":
            return "font-size: 6rem;";
          case "lg":
            return "font-size: 6rem";
         case "xl":
            return "font-size: 1rem";
            
        }
      }
    }
  };
</script>

<style>
  .bbb {
    background-image: url();
  }

  .sectiontitle {
    padding: 3%;
  }




  .cls-1 {
    fill: #72cac6;
  }
</style>